import React from 'react';

// Main Container for the Laptop and Phone mockup
export default function NexGentShowcase() {
  return (
    <div className="relative w-full max-w-6xl mx-auto p-4 md:p-8 flex items-center justify-center bg-transparent">
      {/* Laptop Wrapper (Slate Cyber Metallic Hues) */}
      <div className="relative w-full aspect-[16/10] bg-slate-950 rounded-[3%_3%_1%_1%] p-[1.5%] shadow-[0_25px_60px_-15px_rgba(6,182,212,0.15)] border-2 border-slate-800">
        
        {/* Laptop Screen Inner Bezel */}
        <div className="w-full h-full bg-slate-900 rounded-sm overflow-hidden select-none border border-slate-700/60 relative z-10">
          <DesktopScreenshot />
        </div>
        
        {/* Laptop Bottom Lip/Hinge Base */}
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[105%] h-[2.5%] bg-slate-800 border-t border-slate-700 rounded-b-xl shadow-xl flex justify-center">
          <div className="w-[12%] h-[40%] bg-slate-950 rounded-b-md border-x border-b border-slate-700/40" />
        </div>
      </div>

      {/* Mobile Phone Mockup (Slate Cyber Frame) */}
      <div className="absolute bottom-[-6%] right-[3%] w-[22%] aspect-[9/18.5] bg-slate-950 rounded-[2.5rem] p-[0.8%] shadow-[0_20px_50px_rgba(6,182,212,0.2)] border-[3px] border-slate-700 z-20 hidden sm:block">
        {/* Speaker / Dynamic Island Top Notch */}
        <div className="absolute top-[2.5%] left-1/2 -translate-x-1/2 w-[30%] h-[3%] bg-slate-950 rounded-full z-30 border border-slate-800" />
        {/* Phone Screen Content */}
        <div className="w-full h-full bg-slate-900 rounded-[2.2rem] overflow-hidden border border-slate-800">
          <MobileScreenshot />
        </div>
      </div>
    </div>
  );
}

// --- DESKTOP SCREENSHOT CONTENT (Cyber Dark Edition) ---
const DesktopScreenshot = () => {
  const menuItems = [
    { name: 'Dashboard', active: true, icon: <path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"/> },
    { name: 'Leaders', active: false, icon: <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5-4-8-4z"/> },
    { name: 'Invitations', active: false, icon: <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"/> },
    { name: 'Jobs', active: false, icon: <path d="M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z"/> },
    { name: 'Connections', active: false, icon: <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 1.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/> },
    { name: 'Messages', active: false, icon: <path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z"/> },
    { name: 'Credits', active: false, icon: <path d="M21 18v1c0 1.1-.9 2-2 2H5c-1.11 0-2-.9-2-2V5c0-1.1.89-2 2-2h14c1.1 0 2 .9 2 2v1h-9c-1.11 0-2 .9-2 2v8c0 1.1.89 2 2 2h9zm-9-2h10V8H12v8zm4-2.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/> },
    { name: 'Settings', active: false, icon: <path d="M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z"/> }
  ];

  const leaders = [
    { name: 'Noina Singh', role: 'Engineering Manager', img: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&q=80&w=120', active: true },
    { name: 'Rohit Sharma', role: 'QA Manager', img: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&q=80&w=120', active: true },
    { name: 'Mihir Varma', role: 'Director of Quality', img: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&q=80&w=120', active: false },
    { name: 'Neha Kapoor', role: 'Head of Engineering', img: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&q=80&w=120', active: true }
  ];  

  return (
    <div className="w-full h-full flex font-sans bg-slate-950 text-slate-100">
      {/* Sidebar Navigation */}
      <aside className="w-[22%] bg-slate-900/60 border-r border-slate-800/80 flex flex-col p-[2.5%] space-y-1 backdrop-blur-md">
        {/* Logo */}
        <div className="flex items-center gap-2 mb-6 px-2">
          <svg className="w-6 h-6 text-cyan-400 drop-shadow-[0_0_8px_rgba(34,211,238,0.4)]" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2L2 22h4l6-12 6 12h4L12 2z"/>
          </svg>
          <span className="text-base font-bold tracking-tight text-white">NexGent</span>
        </div>
        
        {/* Nav Links */}
        <nav className="flex-1 space-y-0.5">
          {menuItems.map((item) => (
            <div
              key={item.name}
              className={`flex items-center gap-3 px-3 py-1.5 rounded-lg text-[11px] font-medium transition-all duration-200 cursor-pointer ${
                item.active 
                  ? 'bg-cyan-950/40 text-cyan-400 border border-cyan-800/50 shadow-[inset_0_1px_12px_rgba(6,182,212,0.15)]' 
                  : 'text-slate-400 hover:bg-slate-800/50 hover:text-slate-200'
              }`}
            >
              <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="currentColor">{item.icon}</svg>
              {item.name}
            </div>
          ))}
        </nav>
      </aside>

      {/* Main App Workspace */}
      <main className="flex-1 flex flex-col overflow-y-auto bg-slate-900/40">
        {/* Top Header Bar */}
        <header className="h-12 bg-slate-900/80 border-b border-slate-800/80 flex items-center justify-between px-6 backdrop-blur-md">
          <div className="relative w-72">
            <span className="absolute inset-y-0 left-3 flex items-center text-slate-500">
              <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/></svg>
            </span>
            <input 
              type="text" 
              placeholder="Search leaders by skills, experience, roles..." 
              className="w-full bg-slate-950/60 text-[10px] text-slate-200 pl-9 pr-4 py-1.5 rounded-full border border-slate-800 focus:outline-none focus:border-cyan-500/50 focus:ring-1 focus:ring-cyan-500/30 placeholder-slate-500"
            />
          </div>
          <div className="relative">
            <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&q=80&w=80" alt="profile" className="w-6 h-6 rounded-full border border-cyan-500/30" />
            <span className="absolute bottom-0 right-0 w-2 h-2 bg-emerald-400 rounded-full ring-2 ring-slate-900" />
          </div>
        </header>

        {/* Dynamic Inner Dashboard Page Layout */}
        <div className="p-6 space-y-6 flex-1">
          
          {/* Top Banner Card Promo Section */}
          <div className="bg-gradient-to-r from-slate-900 to-slate-950 rounded-xl p-5 border border-slate-800 shadow-xl flex justify-between items-center relative overflow-hidden group">
            <div className="absolute top-0 right-0 w-48 h-48 bg-cyan-500/5 rounded-full blur-3xl pointer-events-none" />
            
            <div className="space-y-2 max-w-[60%] z-10">
              <h2 className="text-sm font-bold text-white tracking-wide">Find the Right Leadership Talent</h2>
              <p className="text-[10px] text-slate-400 leading-relaxed">Discover verified leaders who drive impact, core optimization, and strategic growth.</p>
              <button className="bg-cyan-500 text-slate-950 font-bold text-[10px] px-4 py-1.5 rounded-lg shadow-[0_0_15px_rgba(6,182,212,0.3)] hover:bg-cyan-400 hover:shadow-[0_0_20px_rgba(6,182,212,0.5)] transition-all duration-200 mt-1">
                Search Leaders
              </button>
            </div>
            
            {/* Embedded Cyberpunk Styled Abstract Vector */}
            <div className="w-[35%] flex items-center justify-center opacity-80">
              <svg viewBox="0 0 200 120" className="w-full h-auto">
                <circle cx="60" cy="60" r="22" fill="#06b6d4" opacity="0.15"/>
                <circle cx="140" cy="60" r="22" fill="#3b82f6" opacity="0.1"/>
                <path d="M40 100c0-12 8-18 20-18s20 6 20 18" fill="#06b6d4" opacity="0.8"/>
                <path d="M120 100c0-12 8-18 20-18s20 6 20 18" fill="#3b82f6" opacity="0.6"/>
                <circle cx="60" cy="54" r="8" fill="#1e293b"/>
                <circle cx="140" cy="54" r="8" fill="#1e293b"/>
                <path d="M85 60h30" stroke="#334155" strokeWidth="2" strokeDasharray="4 3"/>
              </svg>
            </div>
          </div>

          {/* Leaders Recommended Row */}
          <div className="space-y-3">
            <h3 className="text-xs font-bold text-slate-400 tracking-wider uppercase text-[10px]">Recommended Leaders</h3>
            <div className="grid grid-cols-4 gap-4">
              {leaders.map((leader, index) => (
                <div key={index} className="bg-slate-900/80 rounded-xl p-4 border border-slate-800 shadow-lg flex flex-col items-center text-center space-y-2 hover:border-slate-700 transition-all duration-200">
                  <div className="relative">
                    <img src={leader.img} alt={leader.name} className="w-12 h-12 rounded-full object-cover border border-slate-700" />
                    <span className={`absolute bottom-0 right-0 w-2.5 h-2.5 border-2 border-slate-900 rounded-full ${leader.active ? 'bg-cyan-400 shadow-[0_0_6px_#06b6d4]' : 'bg-slate-600'}`}></span>
                  </div>
                  <div>
                    <h4 className="text-[10px] font-bold text-slate-200">{leader.name}</h4>
                    <p className="text-[9px] text-cyan-400/80 font-semibold tracking-wide mt-0.5">{leader.role}</p>
                  </div>
                  {/* Neon Indicator Grid Bar Line Status */}
                  <div className="flex gap-1 pt-1">
                    <span className="w-1.5 h-1 bg-slate-800 rounded-full"></span>
                    <span className="w-3 h-1 bg-cyan-500 rounded-full shadow-[0_0_4px_#06b6d4]"></span>
                    <span className="w-1.5 h-1 bg-slate-800 rounded-full"></span>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </main>
    </div>
  );
};

// --- MOBILE SCREENSHOT CONTENT (Cyber Dark Edition) ---
const MobileScreenshot = () => {
  return (
    <div className="w-full h-full flex flex-col font-sans bg-slate-950 pt-7 p-4 text-slate-300">
      {/* Mini Titlebar Header */}
      <div className="flex items-center justify-between pb-3 border-b border-slate-900">
        <span className="text-[10px] font-bold uppercase tracking-wider text-slate-400">Profile Overview</span>
        <svg className="w-3.5 h-3.5 text-slate-500" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z"/></svg>
      </div>

      {/* Main Container Info Card Profile Area */}
      <div className="flex flex-col items-center text-center mt-3 space-y-2">
        <div className="relative">
          <img 
            src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&q=80&w=120" 
            alt="Noina Singh" 
            className="w-12 h-12 rounded-full border border-cyan-500/40 object-cover p-0.5 shadow-[0_0_10px_rgba(6,182,212,0.2)]"
          />
          <span className="absolute bottom-0 right-0 w-2.5 h-2.5 bg-cyan-400 border-2 border-slate-950 rounded-full" />
        </div>
        <div>
          <h3 className="text-[11px] font-bold text-white">Noina Singh</h3>
          <p className="text-[9px] text-cyan-400 font-semibold tracking-wider">Engineering Manager</p>
        </div>
      </div>

      {/* Structured Category Tags */}
      <div className="flex justify-center gap-1 mt-3">
        {['Leadership', 'Agile', 'Systematic'].map(tag => (
          <span key={tag} className="bg-slate-900 text-slate-400 border border-slate-800/60 text-[8px] font-medium px-2 py-0.5 rounded">
            {tag}
          </span>
        ))}
      </div>

      {/* Content Skeleton Strip Placeholders */}
      <div className="mt-4 space-y-3.5 flex-1">
        {[
          { label: 'Experience', lines: 1 },
          { label: 'Skills', lines: 2 },
          { label: 'Achievements', lines: 1 },
          { label: 'About', lines: 2 }
        ].map((block, idx) => (
          <div key={idx} className="space-y-1.5">
            <h4 className="text-[8px] font-bold text-slate-500 tracking-widest uppercase">{block.label}</h4>
            <div className="space-y-1">
              {Array.from({ length: block.lines }).map((_, lIdx) => (
                <div 
                  key={lIdx} 
                  className={`h-1 bg-slate-900 rounded-full border border-slate-800/40 ${lIdx === block.lines - 1 ? 'w-[65%]' : 'w-full'}`} 
                />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};